import { AxiosResponse } from "axios";
import {
  IRefreshTokenResponse,
  ITokenResponseData,
  IUserLoginRequestData,
} from "../../redux/reducers/user/userTypes";
import { ENDPOINTS } from "./endpoints";
import { studioAxiosInstance } from "./instances";

export const loginAPI = async (
  data: IUserLoginRequestData
): Promise<AxiosResponse<ITokenResponseData>> => {
  return await studioAxiosInstance.post(`/${ENDPOINTS.TOKEN.LOGIN}`, data);
};

export const refreshTokenAPI = async (): Promise<
  AxiosResponse<IRefreshTokenResponse>
> => {
  const authData: string | null = localStorage.getItem("authInfo");
  let refreshToken: string = "";

  if (authData) {
    refreshToken = JSON.parse(authData).refreshToken;
  }

  return await studioAxiosInstance.post(`/${ENDPOINTS.TOKEN.REFRESH}`, {
    refreshToken: refreshToken,
  });
};
